import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    setTimeout(() => {
      $('.grecaptcha-badge').show();
    }, 10);
  }

}
